module.exports = __webpack_public_path__ + "static/media/nus_bachelor_cert.7dcd0125.pdf";